import React from 'react';

export default function LayoutEmbed({ children }) {
  return (
    <>
      {children}
    </>
  );
}
 